import { useState, useEffect } from 'react'

import Navbar from '../Components/Navbar'
import pickup from '../images/sddefault.png'
import lorry from '../images/1000024619.png'
import ScrollDownButton from '../Components/ScrollDownButton';
import cover from '../images/mechanic-73.png'
import boxtruck from '../images/32-feet-box.png'
import tanker from '../images/tanker.png'
import twelve from '../images/12Tyre.png'
import forty from '../images/40-TAILOR.png'
import twenty from '../images/20-TAILOR.png'
import tusker from '../images/tusker.png'
import Toures from '../images/TOURES.png'
import Footer from '../Components/Footer';
import HashLoader from "react-spinners/HashLoader";
import { Link } from 'react-router-dom'

export default function Askrate() {
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    setLoading(true)
    setTimeout(() =>{
      setLoading(false)
    }, 3500)
  }, [])


  
  
  return (
    <>
    {
        loading ?
        <div className="loader">
        <HashLoader color="#36d7b7" /> </div>
        
        :
        
   <></>
    }

    <Navbar page="AskRate"/>
    <div className='bg-cover bg-center h-screen' style = {{
        backgroundImage:
        `url(./images/secondbg.png)`,
        backgroundSize: 'cover',
        width: '100vw', // Set width to 100% of viewport width
        height: '100vh', // Set height to 100% of viewport height
        backgroundRepeat: "no-repeat",
     }}
     >
    <div className='bg-cover bg-center h-screen' style = {{
        backgroundImage:
        `url(${cover})`,
        backgroundSize: 'cover',
        width: '100vw', // Set width to 100% of viewport width
        height: '100vh', // Set height to 100% of viewport height
        backgroundRepeat: "no-repeat",
     }}
     >
 
      <div className='flex mr-2 relative left-3 xl:mr-16 xl:float-right xl:left-0 xl xl:static   items-center h-screen'>
      <div class="wh bg-blue-200 
       rounded overflow-hidden shadow-lg">
  <div class="px-6 py-4">
    <h1 class="font-bold uppercase text-2xl xl:text-4xl mb-2 text-center mt-6">Ask Rate</h1>
    <p class="text-gray-700 text-xl text-center text-base">
      List of our services are given blow 
    </p>
  </div>
  <div class="px-6 flex mt-2 justify-center pt-4 pb-2">
  <ScrollDownButton />
    
  </div>
  </div>
  
</div>
    </div>
    <div className='bg-gray-200'>
  <div className='mb-10' >
    <h1 className='text-2xl uppercase font-bold text-gray-800 pl-20  pt-20 pb-5'>Pickup</h1>
  
    <section className='border border-gray-800 w-28 absolute left-20  drop-shadow-md	'></section>
    <section className='border border-gray-800 w-28 absolute left-20  drop-shadow-md	'></section>
    <div className="flex justify-center items-center">
    <img id="sectionToScrollTo" className='' src={pickup} alt="" />
    </div>
  <div  class="flex justify-center my-2 drop-shadow-lg">
    <a href="#_" class="relative inline-flex items-center justify-center inline-block p-4 px-5 py-3 overflow-hidden font-medium text-indigo-600 rounded-md shadow-2xl group">
        <span class="absolute top-0 left-0 w-40 h-40 -mt-10 -ml-3 transition-all duration-700 bg-amber-300 rounded-full blur-md ease"></span>
        <span class="absolute inset-0 w-full h-full transition duration-700 group-hover:rotate-180 ease">
        <span class="absolute bottom-0 left-0 w-24 h-24 -ml-10 bg-blue-400 rounded-full blur-md"></span>
        <span class="absolute bottom-0 right-0 w-24 h-24 -mr-10 bg-pink-500 rounded-full blur-md"></span>
        </span>
        <Link 
            id="About"            
            to="/contact"><span class="relative text-white">Ask Rate</span>       
            </Link>
        </a>

        
      </div>
    </div>    
    <div className=" mx-auto mb-20 box max-w-6xl	 h-48 bg-white shadow-2xl rounded-md">
      <div className='text-lg xl:text-xl yo2  ml-5 pt-8 '>
      <ul className="gradient-bullet">
      <div className="flex"><li className='gradient-bullet'/><h1>4 Wheeler Pickup</h1></div>
      <div className="flex"><li className='text-pink-400'/><h1>Closed Body</h1></div>
      <div className="flex"><li className='text-pink-400'/><h1>Payload Capacity Upto: 1.5 Matric Tone</h1></div>
      <div className="flex"> <li className='text-pink-400'/><h1>Body Length: 9 Ft</h1></div>
      </ul>
      </div>
      
      </div>  

    {/* Next */}
    <div className='bg-blue-200 pb-2'>
    <h1 className='text-2xl uppercase font-bold text-gray-800 pl-20  pt-20 pb-5'>Lorry</h1>
  
    <section className='border border-gray-800 w-28 absolute left-20  drop-shadow-md	'></section>
    <section className='border border-gray-800 w-28 absolute left-20  drop-shadow-md	'></section>
    <div className="flex justify-center items-center">
    <img className='' src={lorry} alt="" />
    </div>
  <div class="flex justify-center my-2 drop-shadow-lg">
    <a href="#_" class="relative inline-flex items-center justify-center inline-block p-4 px-5 py-3 overflow-hidden font-medium text-indigo-600 rounded-md shadow-2xl group">
        <span class="absolute top-0 left-0 w-40 h-40 -mt-10 -ml-3 transition-all duration-700 bg-amber-300 rounded-full blur-md ease"></span>
        <span class="absolute inset-0 w-full h-full transition duration-700 group-hover:rotate-180 ease">
        <span class="absolute bottom-0 left-0 w-24 h-24 -ml-10 bg-blue-400 rounded-full blur-md"></span>
        <span class="absolute bottom-0 right-0 w-24 h-24 -mr-10 bg-pink-500 rounded-full blur-md"></span>
        </span>
        <Link 
            id="About"            
            to="/contact"><a href="./contact"><span class="relative text-white">Ask Rate</span></a></Link>
        
        </a>
      </div>
      
      <div className=" mx-auto mb-20 box max-w-6xl	 h-48 bg-blue-300 shadow-2xl rounded-md">
      <div className='text-lg xl:text-xl yo2  ml-5 pt-8 '>
      <ul className="gradient-bullet">
      <div className="flex"><li className='gradient-bullet'/><h1>6 Wheeler Truck</h1></div>
      <div className="flex"><li className='text-pink-400'/><h1>Closed Body</h1></div>
      <div className="flex"><li className='text-pink-400'/><h1>Payload Capacity Upto:  9 Matric Tone</h1></div>
      <div className="flex"> <li className='text-pink-400'/><h1>Body Length: 18 Ft</h1></div>
      </ul>
      </div>
      </div>  
      
    </div> 
    
    {/* Next */}
    <div className=''>
    <h1 className='text-2xl uppercase font-bold text-gray-800 pl-20  pt-20 pb-5'>Box Truck</h1>
  
    <section className='border border-gray-800 w-28 absolute left-20  drop-shadow-md	'></section>
    <section className='border border-gray-800 w-28 absolute left-20  drop-shadow-md	'></section>
    <div className="flex justify-center items-center">
    <img className='w-2/4' src={boxtruck} alt="" />
    </div>
  <div class="flex justify-center my-2 drop-shadow-lg">
    <a href="#_" class="relative inline-flex items-center justify-center inline-block p-4 px-5 py-3 overflow-hidden font-medium text-indigo-600 rounded-md shadow-2xl group">
        <span class="absolute top-0 left-0 w-40 h-40 -mt-10 -ml-3 transition-all duration-700 bg-amber-300 rounded-full blur-md ease"></span>
        <span class="absolute inset-0 w-full h-full transition duration-700 group-hover:rotate-180 ease">
        <span class="absolute bottom-0 left-0 w-24 h-24 -ml-10 bg-blue-400 rounded-full blur-md"></span>
        <span class="absolute bottom-0 right-0 w-24 h-24 -mr-10 bg-pink-500 rounded-full blur-md"></span>
        </span>
        <Link  to="/contact"><span class="relative text-white">Ask Rate</span></Link>
        
        </a>
      </div>
      <div className=" mx-auto mb-20 box max-w-6xl	mt-5 h-48 bg-white shadow-2xl rounded-md">
      <div className='text-lg xl:text-xl yo2  ml-5 pt-8 '>
      <ul className="gradient-bullet">
      <div className="flex"><li className='gradient-bullet'/><h1>6 Wheeler Pickup</h1></div>
      <div className="flex"><li className='text-pink-400'/><h1>Closed Body</h1></div>
      <div className="flex"><li className='text-pink-400'/><h1>Payload Capacity Upto: 10 Matric Tone</h1></div>
      <div className="flex"> <li className='text-pink-400'/><h1>Body Length: 32 Ft</h1></div>
      </ul>
      </div>
      
      </div> 
      </div>
          {/* Next */}
    <div className='bg-blue-200 pb-2'>
    <h1 className='text-2xl uppercase font-bold text-gray-800 pl-20  pt-20 pb-5'>Toures</h1>
  
    <section className='border border-gray-800 w-28 absolute left-20  drop-shadow-md	'></section>
    <section className='border border-gray-800 w-28 absolute left-20  drop-shadow-md	'></section>
    <div className="flex justify-center items-center">
    <img className='' src={Toures} alt="" />
    </div>
  <div class="flex justify-center my-2 drop-shadow-lg">
    <a href="#_" class="relative inline-flex items-center justify-center inline-block p-4 px-5 py-3 overflow-hidden font-medium text-indigo-600 rounded-md shadow-2xl group">
        <span class="absolute top-0 left-0 w-40 h-40 -mt-10 -ml-3 transition-all duration-700 bg-amber-300 rounded-full blur-md ease"></span>
        <span class="absolute inset-0 w-full h-full transition duration-700 group-hover:rotate-180 ease">
        <span class="absolute bottom-0 left-0 w-24 h-24 -ml-10 bg-blue-400 rounded-full blur-md"></span>
        <span class="absolute bottom-0 right-0 w-24 h-24 -mr-10 bg-pink-500 rounded-full blur-md"></span>
        </span>
        <Link  to="/contact"><span class="relative text-white">Ask Rate</span></Link>
        
        </a>
      </div>
      <div className=" mx-auto mb-20 box max-w-6xl mt-5	 h-48 bg-blue-300 shadow-2xl rounded-md">
      <div className='text-lg xl:text-xl yo2  ml-5 pt-8 '>
      <ul className="gradient-bullet">
      <div className="flex"><li className='gradient-bullet'/><h1>10 Wheeler Truck</h1></div>
      <div className="flex"><li className='text-pink-400'/><h1>Open Body</h1></div>
      <div className="flex"><li className='text-pink-400'/><h1>Payload Capacity Upto:  15 Matric Tone</h1></div>
      <div className="flex"> <li className='text-pink-400'/><h1>Body Length: 20 Ft</h1></div>
      </ul>
      </div>
      </div>  
    </div> 
              {/* Next */}
              <div className=' pb-2'>
    <h1 className='text-2xl uppercase font-bold text-gray-800 pl-20  pt-20 pb-5'>TUSKER</h1>
  
    <section className='border border-gray-800 w-28 absolute left-20  drop-shadow-md	'></section>
    <section className='border border-gray-800 w-28 absolute left-20  drop-shadow-md	'></section>
    <div className="flex justify-center items-center">
    <img className='' src={tusker} alt="" />
    </div>
  <div class="flex justify-center my-2 drop-shadow-lg">
    <a href="#_" class="relative inline-flex items-center justify-center inline-block p-4 px-5 py-3 overflow-hidden font-medium text-indigo-600 rounded-md shadow-2xl group">
        <span class="absolute top-0 left-0 w-40 h-40 -mt-10 -ml-3 transition-all duration-700 bg-amber-300 rounded-full blur-md ease"></span>
        <span class="absolute inset-0 w-full h-full transition duration-700 group-hover:rotate-180 ease">
        <span class="absolute bottom-0 left-0 w-24 h-24 -ml-10 bg-blue-400 rounded-full blur-md"></span>
        <span class="absolute bottom-0 right-0 w-24 h-24 -mr-10 bg-pink-500 rounded-full blur-md"></span>
        </span>
        <Link  to="/contact"><span class="relative text-white">Ask Rate</span></Link>
        
        </a>
      </div>
      <div className=" mx-auto mb-20 box max-w-6xl	mt-5 h-48 bg-white shadow-2xl rounded-md">
      <div className='text-lg xl:text-xl yo2  ml-5 pt-8 '>
      <ul className="gradient-bullet">
      <div className="flex"><li className='gradient-bullet'/><h1>6 Wheeler Pickup</h1></div>
      <div className="flex"><li className='text-pink-400'/><h1>Open Body</h1></div>
      <div className="flex"><li className='text-pink-400'/><h1>Payload Capacity Upto: 9 Matric Tone</h1></div>
      <div className="flex"> <li className='text-pink-400'/><h1>Body Length: 20 Ft</h1></div>
      </ul>
      </div>
      
      </div>
    </div> 
                  {/* Next */}
                  <div className='bg-blue-200 pb-2'>
    <h1 className='text-2xl uppercase font-bold text-gray-800 pl-20  pt-20 pb-5'>12 Tyre</h1>
  
    <section className='border border-gray-800 w-28 absolute left-20  drop-shadow-md	'></section>
    <section className='border border-gray-800 w-28 absolute left-20  drop-shadow-md	'></section>
    <div className="flex justify-center items-center">
    <img className='' src={twelve} alt="" />
    </div>
  <div class="flex justify-center my-2 drop-shadow-lg">
    <a href="#_" class="relative inline-flex items-center justify-center inline-block p-4 px-5 py-3 overflow-hidden font-medium text-indigo-600 rounded-md shadow-2xl group">
        <span class="absolute top-0 left-0 w-40 h-40 -mt-10 -ml-3 transition-all duration-700 bg-amber-300 rounded-full blur-md ease"></span>
        <span class="absolute inset-0 w-full h-full transition duration-700 group-hover:rotate-180 ease">
        <span class="absolute bottom-0 left-0 w-24 h-24 -ml-10 bg-blue-400 rounded-full blur-md"></span>
        <span class="absolute bottom-0 right-0 w-24 h-24 -mr-10 bg-pink-500 rounded-full blur-md"></span>
        </span>
        <Link  to="/contact"><span class="relative text-white">Ask Rate</span></Link>
        
        </a>
      </div>
      <div className=" mx-auto mb-20 box max-w-6xl mt-5	 h-48 bg-blue-300 shadow-2xl rounded-md">
      <div className='text-lg xl:text-xl yo2  ml-5 pt-8 '>
      <ul className="gradient-bullet">
      <div className="flex"><li className='gradient-bullet'/><h1>12 Wheeler Truck</h1></div>
      <div className="flex"><li className='text-pink-400'/><h1>Open Body</h1></div>
      <div className="flex"><li className='text-pink-400'/><h1>Payload Capacity Upto:  22 Matric Tone</h1></div>
      <div className="flex"> <li className='text-pink-400'/><h1>Body Length: 20 Ft</h1></div>
      </ul>
      </div>
      </div>
    </div> 
                      {/* Next */}
                      <div className='pb-2'>
    <h1 className='text-2xl uppercase font-bold text-gray-800 pl-20  pt-20 pb-5'>20 Tailor</h1>
  
    <section className='border border-gray-800 w-28 absolute left-20  drop-shadow-md	'></section>
    <section className='border border-gray-800 w-28 absolute left-20  drop-shadow-md	'></section>
    <div className="flex justify-center items-center">
    <img className='w-2/4' src={twenty} alt="" />
    </div>
  <div class="flex justify-center my-2 drop-shadow-lg">
    <a href="#_" class="relative inline-flex items-center justify-center inline-block p-4 px-5 py-3 overflow-hidden font-medium text-indigo-600 rounded-md shadow-2xl group">
        <span class="absolute top-0 left-0 w-40 h-40 -mt-10 -ml-3 transition-all duration-700 bg-amber-300 rounded-full blur-md ease"></span>
        <span class="absolute inset-0 w-full h-full transition duration-700 group-hover:rotate-180 ease">
        <span class="absolute bottom-0 left-0 w-24 h-24 -ml-10 bg-blue-400 rounded-full blur-md"></span>
        <span class="absolute bottom-0 right-0 w-24 h-24 -mr-10 bg-pink-500 rounded-full blur-md"></span>
        </span>
        <Link  to="/contact"><span class="relative text-white">Ask Rate</span></Link>
        
        </a>
      </div>
      <div className=" mx-auto mb-20 box max-w-6xl	mt-5 h-48 bg-white shadow-2xl rounded-md">
      <div className='text-lg xl:text-xl yo2  ml-5 pt-8 '>
      <ul className="gradient-bullet">
      <div className="flex"><li className='gradient-bullet'/><h1>14 Wheeler Pickup</h1></div>
      <div className="flex"><li className='text-pink-400'/><h1>Open Body</h1></div>
      <div className="flex"><li className='text-pink-400'/><h1>Payload Capacity Upto: 25 Matric Tone</h1></div>
      <div className="flex"> <li className='text-pink-400'/><h1>Body Length: 20 Ft</h1></div>
      </ul>
      </div>
      
      </div>
    </div> 
              {/* Next */}
              <div className='bg-blue-200 pb-2'>
    <h1 className='text-2xl uppercase font-bold text-gray-800 pl-20  pt-20 pb-5'>40  Tailor</h1>
  
    <section className='border border-gray-800 w-28 absolute left-20  drop-shadow-md	'></section>
    <section className='border border-gray-800 w-28 absolute left-20  drop-shadow-md	'></section>
    <div className="flex justify-center items-center">
    <img  src={forty} alt="" />
    </div>
  <div class="flex justify-center my-2 drop-shadow-lg">
    <a href="#_" class="relative inline-flex items-center justify-center inline-block p-4 px-5 py-3 overflow-hidden font-medium text-indigo-600 rounded-md shadow-2xl group">
        <span class="absolute top-0 left-0 w-40 h-40 -mt-10 -ml-3 transition-all duration-700 bg-amber-300 rounded-full blur-md ease"></span>
        <span class="absolute inset-0 w-full h-full transition duration-700 group-hover:rotate-180 ease">
        <span class="absolute bottom-0 left-0 w-24 h-24 -ml-10 bg-blue-400 rounded-full blur-md"></span>
        <span class="absolute bottom-0 right-0 w-24 h-24 -mr-10 bg-pink-500 rounded-full blur-md"></span>
        </span>
        <Link  to="/contact"><span class="relative text-white">Ask Rate</span></Link>
        
        </a>
      </div>
      <div className=" mx-auto mb-20 box max-w-6xl mt-5	 h-48 bg-blue-300 shadow-2xl rounded-md">
      <div className='text-lg xl:text-xl yo2  ml-5 pt-8 '>
      <ul className="gradient-bullet">
      <div className="flex"><li className='gradient-bullet'/><h1>14 Wheeler Truck</h1></div>
      <div className="flex"><li className='text-pink-400'/><h1>Open Body</h1></div>
      <div className="flex"><li className='text-pink-400'/><h1>Payload Capacity Upto:  25 Matric Tone</h1></div>
      <div className="flex"> <li className='text-pink-400'/><h1>Body Length: 40 Ft</h1></div>
      </ul>
      </div>
      </div>
    </div> 
    
                          {/* Next */}
                          <div className='pb-12'>
    <h1 className='text-2xl uppercase font-bold text-gray-800 pl-20  pt-20 pb-5'>Tankar</h1>
  
    <section className='border border-gray-800 w-28 absolute left-20  drop-shadow-md	'></section>
    <section className='border border-gray-800 w-28 absolute left-20  drop-shadow-md	'></section>
    <div className="flex justify-center items-center">
    <img className='w-3/6' src={tanker} alt="" />
    </div>
  <div class="flex justify-center my-2 drop-shadow-lg">
    <a href="#_" class="relative inline-flex items-center justify-center inline-block p-4 px-5 py-3 overflow-hidden font-medium text-indigo-600 rounded-md shadow-2xl group">
        <span class="absolute top-0 left-0 w-40 h-40 -mt-10 -ml-3 transition-all duration-700 bg-amber-300 rounded-full blur-md ease"></span>
        <span class="absolute inset-0 w-full h-full transition duration-700 group-hover:rotate-180 ease">
        <span class="absolute bottom-0 left-0 w-24 h-24 -ml-10 bg-blue-400 rounded-full blur-md"></span>
        <span class="absolute bottom-0 right-0 w-24 h-24 -mr-10 bg-pink-500 rounded-full blur-md"></span>
        </span>
        <Link  to="/contact"><span class="relative text-white">Ask Rate</span></Link>
        
        </a>
      </div>
      
    </div>
    <div className=" mx-auto mb-20 box max-w-6xl	mt-5 h-32 bg-white shadow-2xl rounded-md mb-12">
      <div className='text-lg xl:text-xl yo2  ml-5 pt-8 '>
      <ul className="gradient-bullet">
      <div className="flex"><li className='gradient-bullet'/><h1>12 Wheeler Pickup</h1></div>
      <div className="flex"><li className='text-pink-400'/><h1>Payload Capacity Upto: 22 Matric Tone/29 kl</h1></div>
      
      </ul>
      </div>
      
      </div>
      <div className="">
  <Footer/>
  </div> 
    </div>
    
</div>    

    </>
    
  )
}
